import { render, staticRenderFns } from "./AamsGiftRegSubmission.vue?vue&type=template&id=edfcc5b0&scoped=true&"
import script from "./AamsGiftRegSubmission.vue?vue&type=script&lang=js&"
export * from "./AamsGiftRegSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfcc5b0",
  null
  
)

export default component.exports